var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-textarea',{ref:'field-' + _vm.field.name,staticClass:"dynamic-textarea",attrs:{"plaintext":_vm.viewMode,"name":_vm.field.name,"id":_vm.field.name,"required":_vm.field.required,"placeholder":"...","value":_vm.fieldValue}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08fa69f3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForms/Textarea.vue
// module id = 796
// module chunks = 3